import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';

const StickyCTA = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !phone) return;

    setIsLoading(true);
    
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/contacts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, phone, source: 'sticky_cta' }),
      });

      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message || 'Děkujeme! Brzy se vám ozveme.');
        setEmail('');
        setPhone('');
      } else {
        toast.error(data.detail || 'Něco se pokazilo.');
      }
    } catch (error) {
      toast.error('Nepodařilo se odeslat. Zkuste to prosím znovu.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-[color:var(--border)] bg-white/95 backdrop-blur-lg shadow-xl px-4 py-4 pb-[max(env(safe-area-inset-bottom),16px)]"
      data-testid="sticky-cta-bar"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex-shrink-0">
            <p className="text-sm md:text-base font-semibold text-[color:var(--text-primary)]">
              Máte zájem o více informací?
            </p>
            <p className="text-xs text-[color:var(--text-secondary)] hidden sm:block">
              Nechte nám kontakt a ozveme se vám
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex gap-2 w-full sm:w-auto">
            <Input
              type="email"
              placeholder="Váš e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              className="h-11 w-full sm:w-48 bg-white"
            />
            <Input
              type="tel"
              placeholder="Telefon"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              disabled={isLoading}
              className="h-11 w-full sm:w-40 bg-white"
            />
            <Button
              type="submit"
              disabled={isLoading}
              className="h-11 px-6 bg-[color:var(--primary-500)] hover:bg-[color:var(--primary-600)] text-white rounded-xl font-semibold shadow-md"
            >
              {isLoading ? 'Odesílám...' : 'Odeslat'}
            </Button>
          </form>

          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-3 right-3 sm:relative sm:top-0 sm:right-0 p-1 text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)] transition-colors rounded-lg hover:bg-[color:var(--bg)]"
            aria-label="Zavřít"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;